var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactusEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "contactUs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "FLT_ART_WORKS",
    "data-name": "FLT ART WORKS"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "144.48 68.85 127.03 68.85 130.79 72.61 124.42 78.98 117.62 72.18 114.58 75.22 111.97 68.85 55.49 68.85 55.49 16.41 144.54 16.41 144.48 68.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "142.85 19.22 99.51 52.36 56.96 19.17",
    style: {
      fill: "none",
      stroke: "#1a5336",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.04,
    y1: 66.96,
    x2: 84.28,
    y2: 40.51,
    style: {
      fill: "none",
      stroke: "#1a5336",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.43,
    y1: 66.96,
    x2: 115.19,
    y2: 40.51,
    style: {
      fill: "none",
      stroke: "#1a5336",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.99 67.35 56.99 67.35 56.99 17.91 143.04 17.91 142.99 67.35",
    style: {
      fill: "none",
      stroke: "#1a5336",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.38 63.3 108.68 56.87 115.11 72.57 117.62 70.06 124.42 76.86 128.67 72.61 121.87 65.81 124.38 63.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.73 67.82 125.53 74.63 128.02 72.14 121.22 65.33 123.29 63.26 112.03 58.64 116.65 69.9 118.73 67.82",
    style: {
      fill: "#00b624"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.38 63.3 108.68 56.87 115.11 72.57 117.62 70.06 124.42 76.86 128.67 72.61 121.87 65.81 124.38 63.3",
    style: {
      fill: "none",
      stroke: "#1a5336",
      strokeLinecap: "square",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactusEn);
export default __webpack_public_path__ + "static/media/contactus-en.242bcdd6f10605a1c33e07b20d21aaf5.svg";
export { ForwardRef as ReactComponent };